import { Menu, MenuItem } from "@mui/material";
import { Download } from "@mui/icons-material";

import type { JobsDashboardTableViewModel, DownloadMenuContext } from "../JobsDashboardTable.types";

export interface DownloadMenuProps {
	vm: JobsDashboardTableViewModel;
	downloadCtx: DownloadMenuContext;
}

export function DownloadMenu({ vm, downloadCtx }: DownloadMenuProps) {
	return (
		<Menu
			anchorEl={vm.actionMenuElement}
			open={Boolean(vm.actionMenuElement)}
			onClose={() => vm.setActionMenuElement(null)}
		>
			<MenuItem key="header">
				<strong>Files for {downloadCtx.itemName}</strong>
			</MenuItem>
			<MenuItem
				key="all-files"
				onClick={vm.downloadFiles(
					vm.jobs.map((job) => job.id),
					downloadCtx.allFiles,
					"All Files",
					downloadCtx.itemName,
				)}
			>
				<Download /> All Files
			</MenuItem>
			{downloadCtx.fileItems.map(({ menuItem, files, rowName }) =>
				files.length > 0 ? (
					<MenuItem
						key={menuItem.label.toLowerCase().replace(/\s+/g, "-")}
						onClick={vm.downloadFiles([vm.actionMenuRow?.original?.id ?? ""], files, menuItem.label, rowName)}
					>
						<Download /> {menuItem.label}
					</MenuItem>
				) : (
					<MenuItem key={menuItem.property} disabled>
						<Download /> {menuItem.label}
					</MenuItem>
				),
			)}
			{downloadCtx.showMergedCSV && (
				<MenuItem
					key="sampling-csv-merged"
					onClick={vm.downloadFiles(
						vm.selectedJobs.filter((j) => !!j).map((job) => job.id),
						downloadCtx.mergedCSVFiles,
						"Sampling CSV (Merged)",
						downloadCtx.itemName,
						true,
					)}
				>
					<Download /> Sampling CSV (Merged)
				</MenuItem>
			)}
			{vm.user?.isDev && downloadCtx.jobId !== "" && (
				<MenuItem key="job-id" onClick={vm.copyJobId}>
					<strong>{downloadCtx.jobId}</strong>
				</MenuItem>
			)}
		</Menu>
	);
}
